import { render, staticRenderFns } from "./terveyskeskuskoulutusjaksot-yek.vue?vue&type=template&id=3cce83c3&scoped=true&"
import script from "./terveyskeskuskoulutusjaksot-yek.vue?vue&type=script&lang=ts&"
export * from "./terveyskeskuskoulutusjaksot-yek.vue?vue&type=script&lang=ts&"
import style0 from "./terveyskeskuskoulutusjaksot-yek.vue?vue&type=style&index=0&id=3cce83c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cce83c3",
  null
  
)

export default component.exports